import React from "react"
import _ from "lodash"
import { startOfMonth, endOfMonth, isSameDay, parseISO } from "date-fns"
import { MdClear, MdCheck, MdFileDownload, MdInsertPhoto } from "react-icons/md"
import Crud from "~/components/crud"
import { formats } from "~/helper"
import confirm from "~/components/confirm"
import { Container, RoleContainer, EventInclude, Warning } from "~/views/report-event/styles"
import useReportEvent from "~/view-data/use-report-event"
import useHeader from "~/view-data/use-header"
import Filter from "~/views/report-event/filter"
import FloatingButton from "~/components/floatbutton"
import { IconButton } from "~/components/crud/styles"
import { ProtocolCOVIDModal } from "../match-day/covid"

const getColumns = (actions) => [
  {
    name: "Nome do evento",
    selector: "event",
    width: "200px",
    format: (r) => _.get(r, "event.name"),
  },
  {
    name: "Local do evento",
    selector: "event",
    width: "150px",
    format: (r) => _.get(r, "event.place.name"),
  },
  {
    name: "Data do evento",
    selector: "event",
    width: "115px",
    format: (r) =>
      formats.dateTimeZone(_.get(r, "event.eventDate"), "dd/MM/yyyy"),
  },
  {
    name: "É imprensa?",
    selector: "company",
    width: "100px",
    center: true,
    format: (r) => (_.get(r, "company.isPress") ? "Sim" : "Não"),
  },
  {
    name: "Fornecedor",
    selector: "identify",
    format: (r) =>
      `${formats.cnpj(_.get(r, "company.identify")) ||
        _.get(r, "company.identify") ||
        ""} - ${_.get(r, "company.name")}`,
  },
  {
    name: "Colaborador",
    selector: "person",
    width: "360px",
    format: (r) => {
      const vaccinationCertificate = _.get(r, "person.vaccinationCertificate")
      const checkUpPCR = _.get(r, "person.checkUpPCR")
      const hasPCovid = () => vaccinationCertificate || checkUpPCR
      const title = `${formats.cpf(_.get(r, "person.identify")) ||
        _.get(r, "person.identify") ||
        ""} - ${_.get(r, "person.name")}`

      return (
        <RoleContainer>
          <span title={title}>{title}</span>
          <IconButton
            size={26}
            title="Protocolo COVID"
            disabled={!hasPCovid()}
            color={hasPCovid() ? "green" : "red"}
            onClick={() => actions.openCovidModal(r)}
          >
            <MdInsertPhoto />
          </IconButton>
        </RoleContainer>
      )
    },
  },
  {
    name: "Função",
    selector: "person",
    width: "100px",
    format: (r) => _.get(r, "person.role.name"),
  },
  {
    name: "Inclusão no evento",
    selector: "createdAt",
    width: "170px",
    format: (r) => {
      const createAt = parseISO(_.get(r, "createdAt"))
      const eventDate = parseISO(_.get(r, "event.eventDate"))
      return (
        <EventInclude>
          <span>{formats.dateTimeZone(createAt, "dd/MM/yyyy HH:mm")}</span>
          {isSameDay(createAt, eventDate) ? <Warning title='Inserido no dia do "Match day"'/> : null}
        </EventInclude>
      )
    },
  },
  {
    name: "Data Check-in",
    selector: "event",
    width: "140px",
    format: (r) =>
      formats.dateTimeZone(_.get(r, "checkInDate"), "dd/MM/yyyy HH:mm"),
  },
  {
    name: "Data Check-out",
    selector: "event",
    width: "140px",
    format: (r) =>
      formats.dateTimeZone(_.get(r, "checkOutDate"), "dd/MM/yyyy HH:mm"),
  },
]

function ReportEvent({ acls }) {
  const { state, actions } = useReportEvent()
  const { state: headerState } = useHeader()
  const showFilter = _.get(headerState, "filter.visible")

  const handleExport = async () => {
    const result = await confirm.show({
      title: "Atenção",
      text: `Deseja baixar a planilha?`,
    })

    if (result) {
      actions.downloadXlsx()
    }
  }

  return (
    <Container>
      {!_.isEmpty(state.data) && !showFilter && (
        <FloatingButton
          icon={MdFileDownload}
          title="Baixar planilha"
          onClick={handleExport}
        />
      )}

      <Crud
        openForm={showFilter}
        useOpenForm={true}
        hideAdd={true}
        columns={getColumns(actions)}
        emptyText="Nenhum colaborador encontrado"
        data={state.data}
        tableLoading={state.loading}
        onChangePage={actions.pageChange}
        onCloseFilter={actions.hideForm}
        formTitle={(data) => "Filtro"}
        formOptions={{
          onSubmit: actions.list,
          initialValues: _.get(headerState, "filter.data") || {},
        }}
        dataTableOptions={{
          ignoreRowClicked: true,
          selectableRows: false,
          selectableRowsHighlight: false,
        }}
        renderForm={(args) => (
          <Filter
            {...args}
            onListEvents={actions.listEvents}
            onListSuppliers={actions.listSuppliers}
          />
        )}
        actions={[
          {
            label: "Limpar Filtro",
            icon: MdClear,
            action: (a) => {
              let now = new Date()
              actions.changeFilter({
                event: null,
                supplier: null,
                personName: null,
                personIdentitify: null,
                eventDateStart: startOfMonth(now),
                eventDateEnd: endOfMonth(now),
                offset: 0,
              })
            },
          },
          {
            label: "Aplicar Filtro",
            icon: MdCheck,
            action: actions.changeFilter,
            isDisabled: ({ values }) =>
              _.isEmpty(values.event) &&
              _.isEmpty(values.supplier) &&
              !values.personName &&
              !values.personIdentitify,
          },
        ]}
      />
      <ProtocolCOVIDModal
        data={state.modalPCovidData}
        isOpen={state.showCovidModal}
        closeModal={actions.closeCovidModal}
        title={<>Protocolo COVID</>}
        width="60%"
      />
    </Container>
  )
}

export default ReportEvent
